export default {
	DUPLICATE_ON_EDIT: 1,
	NOT_DUPLICATE_ON_EDIT: 2,
}
